(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puzzlebox-audio-previews"] && !Shopify.designMode) return;
  try {
    
  // A document-level capture listener also covers sections reloaded by the theme editor.
  // If either the new or currently playing audio belongs to this section, pause the other.
  if (!window.puzzleboxAudioPreviewsBound) {
    window.puzzleboxAudioPreviewsBound = true;
    document.addEventListener('play', function (event) {
      const current = event.target;
      if (!(current instanceof HTMLAudioElement)) return;
      const isPreview = current.closest('[data-pb-audio-previews]');
      document.querySelectorAll('audio').forEach(function (audio) {
        if (audio !== current && (isPreview || audio.closest('[data-pb-audio-previews]'))) {
          audio.pause();
        }
      });
    }, true);
  }

  } catch(e) { console.error(e); }
})();
})();
